import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListWallet from './submodules/list/List';
import CreateWallet from './submodules/create';
import EditCoupon from './submodules/edit';
import UpdatePriorityList from './submodules/updatePriorityList';

const cashbackUtilDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.cashbackUtil}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].getCashbackUtils]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListWallet}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.cashbackUtil}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].addedCashbackSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateWallet}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.cashbackUtil}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].editCashbackSegments]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.cashbackUtil}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].updatePriorityList]}
				path={`${path}/updatePriorityList`}
				configPageName={PAGE_NAMES.dashboard}
				component={UpdatePriorityList}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default cashbackUtilDashboard;
